// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-empty {
  min-height: 55px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: #eef3f7;
  border-radius: 6px;
  color: #6b6b6b;
  font-size: 15px;
}

.stock-empty-hint {
  margin-left: 6px;
  opacity: 0.85;
}

.stock-item-add {
  width: 36px;
  height: 36px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border: 0;
  background: transparent;
  color: #1f1f1f;

  border-radius: 6px;
  cursor: pointer;
}

.stock-item-add:hover {
  background: rgba(0, 0, 0, 0.06);
}

.stock-item-add:active {
  background: rgba(0, 0, 0, 0.10);
}

.stock-item-add:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.35);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/web/component/ItemListEdit/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,SAAS;EACT,uBAAuB;EACvB,cAAc;;EAEd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB","sourcesContent":[".stock-empty {\r\n  min-height: 55px;\r\n  padding: 0 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  background: #eef3f7;\r\n  border-radius: 6px;\r\n  color: #6b6b6b;\r\n  font-size: 15px;\r\n}\r\n\r\n.stock-empty-hint {\r\n  margin-left: 6px;\r\n  opacity: 0.85;\r\n}\r\n\r\n.stock-item-add {\r\n  width: 36px;\r\n  height: 36px;\r\n\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  border: 0;\r\n  background: transparent;\r\n  color: #1f1f1f;\r\n\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.stock-item-add:hover {\r\n  background: rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.stock-item-add:active {\r\n  background: rgba(0, 0, 0, 0.10);\r\n}\r\n\r\n.stock-item-add:focus-visible {\r\n  outline: 2px solid rgba(0, 0, 0, 0.35);\r\n  outline-offset: 2px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
